/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuditEntry } from '../models/audit-entry';
import { FormAuditUpdateResponseDto } from '../models/form-audit-update-response-dto';
import { list } from '../fn/audit-forms/list';
import { List$Params } from '../fn/audit-forms/list';
import { updateAuditStatus } from '../fn/audit-forms/update-audit-status';
import { UpdateAuditStatus$Params } from '../fn/audit-forms/update-audit-status';
import { updateFormAudit } from '../fn/audit-forms/update-form-audit';
import { UpdateFormAudit$Params } from '../fn/audit-forms/update-form-audit';

@Injectable({ providedIn: 'root' })
export class AuditFormsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `formControllerUpdateFormAudit()` */
  static readonly FormControllerUpdateFormAuditPath = '/auditing/forms/{formId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFormAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFormAudit$Response(
    params: UpdateFormAudit$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<FormAuditUpdateResponseDto>> {
    return updateFormAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFormAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFormAudit(params: UpdateFormAudit$Params, context?: HttpContext): Observable<FormAuditUpdateResponseDto> {
    return this.updateFormAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<FormAuditUpdateResponseDto>): FormAuditUpdateResponseDto => r.body)
    );
  }

  /** Path part for operation `formControllerUpdateAuditStatus()` */
  static readonly FormControllerUpdateAuditStatusPath = '/auditing/forms/{formId}/status/{formStatus}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAuditStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateAuditStatus$Response(
    params: UpdateAuditStatus$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<FormAuditUpdateResponseDto>> {
    return updateAuditStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAuditStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateAuditStatus(params: UpdateAuditStatus$Params, context?: HttpContext): Observable<FormAuditUpdateResponseDto> {
    return this.updateAuditStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<FormAuditUpdateResponseDto>): FormAuditUpdateResponseDto => r.body)
    );
  }

  /** Path part for operation `formControllerList()` */
  static readonly FormControllerListPath = '/auditing/forms/{formId}/{entityClass}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `list()` instead.
   *
   * This method doesn't expect any request body.
   */
  list$Response(params: List$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuditEntry>>> {
    return list(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `list$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  list(params: List$Params, context?: HttpContext): Observable<Array<AuditEntry>> {
    return this.list$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AuditEntry>>): Array<AuditEntry> => r.body)
    );
  }
}
